import type { Action } from "../../actions/types";

export type StoreState = boolean;

export const initialState = false;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "PDP_POINTS_TOTAL_FAILURE":
    case "PDP_POINTS_TOTAL_SUCCESS":
      return false;

    case "PDP_POINTS_TOTAL_REQUEST":
      return true;

    default:
      return state;
  }
}
